import React, {useEffect, useState} from "react";
import Filter from "../Consulta/components/Filter";
import AddDocumentIcon from "../../../components/Icon/AddCocumentIcon";
import Scroll from "../../../components/InfiniteScroll/Scroll";
import Table from "../../../components/Table/Table";
import Notification from "../../../components/Notification";
import {withStyles} from "@material-ui/core";
import {observer} from "mobx-react-lite";
import {inject} from "mobx-react";
import ModalIncluirExamePacsweb from "./ModalIncluirExamePacsweb";
import ModalViewerExame from "./ModalViewerExame";
import {buscarResultadoExame, findAllExamesPacsweb} from "../../../services/ExamePacswebService";
import {gerarUrlViewerExame} from "../../../services/SolicitacoesPacientesService";
import {columns} from "../ExamesPacsweb/Constants";

const ExamesPacsweb = observer(({ classes, sujeitoAtencaoStore ,history}) => {
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [exames, setExames] = useState([]);
  const [last, setLast] = useState(false);
  const [notification, setNotification] = useState({
    isOpen: false,
    message: "",
    variant: "",
  });
  const [pageNumber, setPagenumber] = useState(0);
  const [openModalIncluir, setOpenModalIncluir] = useState(false);
  const [ordenacao, setOrdenacao] = useState({ sortField: "atendimentoDataHora", sortDir: "DESC" });

  useEffect(() => {
    if (sujeitoAtencaoStore?.objView?.id) {
      findAllExames({ resetValues: true });
    }
  }, [sujeitoAtencaoStore?.objView?.id]);

  useEffect(() => {
    if (history?.location?.agendamento) {
      setOpenModalIncluir(true);
    }
  }, [history?.location?.agendamento])

  const findAllExames = async (resetValues) => {
    try {
      if (isLoading) return;
      setIsLoading(true);

      const { content, last } = await findAllExamesPacsweb({
        sujeitoAtencaoId: sujeitoAtencaoStore?.objView?.id,
        search,
        pageableDto: {
          pageNumber: resetValues ? 0 : pageNumber,
          pageSize: 30,
          sortField: ordenacao.sortField,
          sortDir: ordenacao.sortDir,
        },
      });

      setExames((prev) => (resetValues ? content : [...prev, ...content]));
      setLast(last);
      setPagenumber(resetValues ? 1 : pageNumber + 1);
    } catch (error) {
      showAlertMessage({
        isOpen: true,
        message: "Erro ao carregar exames!",
        variant: "error",
      });
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    setSearch(e);
  };

  const closeAlertMessage = () => {
    setNotification({
      isOpen: false,
      message: "",
      variant: "",
    });
  };

  const showAlertMessage = (notificationData) => {
    setNotification(notificationData);

    const timeoutId = setTimeout(() => {
      closeAlertMessage();
      clearTimeout(timeoutId);
    }, 3000);
  };

  const handleClickOrdenar = (field) => {
    const sortDir = ordenacao.sortField !== field
      ? "ASC"
      : ordenacao.sortDir === "ASC" ? "DESC" : "ASC";
    setOrdenacao({ sortField: field, sortDir });
  };

  useEffect(() => {
    if (sujeitoAtencaoStore?.objView?.id) {
      findAllExames({ resetValues: true });
    }
  }, [ordenacao]);

  const onclickAdicionarExame = () => {
    setOpenModalIncluir(true);
  };

  const [viewerModal, setViewerModal] = useState({ open: false, url: "", loading: false });
  const [loadingBuscarResultado, setLoadingBuscarResultado] = useState(null);

  const handleBuscarResultado = async (exame) => {
    if (loadingBuscarResultado) return;
    setLoadingBuscarResultado(exame.id);
    try {
      await buscarResultadoExame(exame.id);
      showAlertMessage({ isOpen: true, message: "Resultado buscado com sucesso!", variant: "success" });
      findAllExames({ resetValues: true });
    } catch (error) {
      showAlertMessage({ isOpen: true, message: error.message, variant: "error" });
    } finally {
      setLoadingBuscarResultado(null);
    }
  };

  const handleVisualizarImagem = async (exame) => {
    const pacienteAnexoId = exame?.pacienteAnexo?.id;
    if (!pacienteAnexoId) {
      showAlertMessage({ isOpen: true, message: "Exame sem imagem vinculada.", variant: "error" });
      return;
    }
    setViewerModal({ open: true, url: "", loading: true });
    try {
      const url = await gerarUrlViewerExame(pacienteAnexoId);
      if (url && url.startsWith("http")) {
        setViewerModal({ open: true, url, loading: false });
      } else {
        setViewerModal({ open: false, url: "", loading: false });
        showAlertMessage({ isOpen: true, message: url || "Não foi possível gerar a URL do viewer.", variant: "error" });
      }
    } catch (error) {
      setViewerModal({ open: false, url: "", loading: false });
      showAlertMessage({ isOpen: true, message: error.message, variant: "error" });
    }
  };

  const onSaveExame = () => {
    findAllExames({ resetValues: true });
    setOpenModalIncluir(false);
    history.location.agendamento = null
  };

  return (
    <div className={classes.wrapper}>
      <Filter
        onChange={handleFilterChange}
        filter={{ search: search }}
        isLoading={isLoading}
        secondaryButton={{
          label: "Incluir exame",
          icon: <AddDocumentIcon />,
          onClick: onclickAdicionarExame,
        }}
        label={"Pesquisar Exame"}
        placeholder={"Exame"}
        hideFilterButton
        handleApplyFilter={() => findAllExames({ resetValues: true })}
        onClickFilterButton={() => findAllExames({ resetValues: true })}
      />
      <Scroll
        classes={{ root: classes.rootScroll }}
        hasMore={!last}
        pageStart={0}
        initialLoad={false}
        loadMore={() => findAllExames()}
      >
        <Table
          dados={exames}
          columns={columns({ handleVisualizarImagem, handleBuscarResultado, loadingBuscarResultado })}
          emptyMessage={"Nenhum exame encontrado"}
          isLoading={isLoading}
          comOrdenacao
          handleClickOrdenar={handleClickOrdenar}
          ordenarTabela={ordenacao}
        />
      </Scroll>
      {openModalIncluir && (
        <ModalIncluirExamePacsweb
          open={openModalIncluir}
          onClose={() => setOpenModalIncluir(false)}
          onSave={onSaveExame}
          sujeitoAtencao={sujeitoAtencaoStore?.objView}
          showAlertMessage={showAlertMessage}
          history={history}
        />
      )}
      <ModalViewerExame
        open={viewerModal.open}
        onClose={() => setViewerModal({ open: false, url: "", loading: false })}
        url={viewerModal.url}
        loading={viewerModal.loading}
      />
      <Notification
        close={closeAlertMessage}
        reset={closeAlertMessage}
        isOpen={notification.isOpen}
        variant={notification.variant}
        message={notification.message}
      />
    </div>
  );
});

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    background: "#f2f2f2",
    padding: "10px",
  },
  rootScroll: {
    height: "calc(100vh - 258px)",
    background: "#fff",
    borderRadius: "20px",
  },
};

const stores = ["sujeitoAtencaoStore"];
const ExamesPacswebWithStyles = withStyles(styles)(ExamesPacsweb);
export default inject(...stores)(ExamesPacswebWithStyles);
